import { toast } from "react-toastify";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface DeletedAddress {
  id: number;
  addressLine1: string | null;
  addressLine2: string | null;
  addressLine3: string | null;
  pinCode: string;
  blockCode: string;
  addressCode: string;
  latitude: string;
  longitude: string;
  userId: number;
  userName: string | null;
  addressTypeId: number;
  createdDate: string;
  updatedDate: string;
  status: boolean;
  pbdpPinCode: string | null;
  stateId: number | null;
  isPrivate: boolean;
  addressType: string | null;
}

export async function getAllDeletedAddressAsync(
  token: string,
  t: (key: string) => string
): Promise<DeletedAddress[]> {

  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return [];
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/GetAllDeletedAddressAsync`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    } 

    const data: unknown = await response.json();

    if (!Array.isArray(data)) {
      console.error("Invalid API response:", data);
      return [];
    }

    return data as DeletedAddress[];

  } catch (error) {
    console.error("Error fetching deleted addresses:", error);
    toast.error(t("somethingWentWrong"));
    return [];
  }
}